module.exports = __webpack_public_path__ + "static/media/lens_classic-Natural.cb9ce3a1.png";